module.exports = __webpack_public_path__ + "static/media/logo_nippon.5cce84b2.png";